<header>
  <div class="subtitle-medium">Perfil {{profileType}}</div>
  <i class="ri-settings-3-line" (click)="irConfiguracion()" style="cursor: pointer;"></i>
</header>
<div class="profile-wrapper">
  <div class="shortname headline-x-small">{{user?.NombreUsuario || user?.NombreOrganizacion | shortName}}</div>
  <div class="profile-name">
    <div class="subtitle-large">{{ user?.NombreUsuario || user?.NombreOrganizacion }}</div>
    <div class="body-x-small">{{ user?.NombreRol }}</div>
  </div>
</div>
<div class="divider"></div>
<yalo-select (change)="setOrganization($event)" [value]="OrganizacionActiva" placeholder="Empresas" *ngIf="profileType === 'empresarial' && OrganizacionActiva && Organizaciones.length > 1">
  <option *ngFor="let item of Organizaciones; index as i" [value]="item.CodOrganizacion">{{item.NombreOrganizacion}}</option>
</yalo-select>
<div class="profile-actions">
  <div class="profile-action" *ngFor="let action of actions" (click)="action.action()">
    <i [class]="action.icon"></i>
    <div class="button-default-text" style="color: var(--blue500);">{{action.title}}</div>
  </div>
</div>
